import config from "@/config";

const defaultHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
  X_REQUESTED_WITH: "XMLHttpRequest",
};

export type GenericPayload = {
  type: string;
  text: string;
  captchaToken: string;
};

export type HelpMeWritePayload = {
  type: string;
  tone: string;
  scenario: string;
  context: string;
  captchaToken: string;
};

export type GenerateCompletionPayload = HelpMeWritePayload | GenericPayload;

export const generateCompletion = async (data: GenerateCompletionPayload) => {
  let res = null;

  try {
    res = await fetch(`${config.baseUrl}/ajax/completion`, {
      method: "POST",
      headers: defaultHeaders,
      body: JSON.stringify(data),
    });

    const resData = await res.json();
    resData.statusCode = res.status;

    return resData;
  } catch (error) {
    throw new Error(
      "We are unable to get AI answer. Please try again. If the issue keep happening, contact Support.",
    );
  }
};
